import { checkNickname, gameSettings } from "@kalaporssi/shared";
import { type FormEvent, useState } from "react";
import { Navigate, useNavigate, useParams } from "react-router";
import { Board } from "../components/Board";
import { ErrorBox, Loading } from "../components/Misc";
import { api, readPlayerSession, savePlayerSession } from "../lib/api";
import { useGame } from "../lib/game";

export function Join() {
  const code = (useParams().code ?? "").toUpperCase();
  const nav = useNavigate();
  const { state, error: loadError } = useGame(code);
  const [nickname, setNickname] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const already = readPlayerSession(code);

  if (already) return <Navigate to={`/g/${code}`} replace />;

  const check = checkNickname(nickname);
  const submit = async (e: FormEvent) => {
    e.preventDefault();
    if (!check.ok) return;
    setBusy(true);
    try {
      const r = await api().joinGame(code, check.nickname);
      savePlayerSession(code, r);
      nav(`/g/${code}`, { replace: true });
    } catch (err) {
      setError(err);
      setBusy(false);
    }
  };

  return (
    <>
      <Board players={state?.players} />
      <main className="stack">
        <div className="monthhead">
          <h2>Liity peliin {code}</h2>
        </div>
        <ErrorBox error={loadError} />
        {!state && !loadError && <Loading />}
        {state && state.status !== "LOBBY" && (
          <div className="panel">
            <p>Peli on jo alkanut, joten siihen ei voi enää liittyä.</p>
          </div>
        )}
        {state?.status === "LOBBY" && (
          <form className="panel stack" onSubmit={submit}>
            <label htmlFor="nick" className="h3label">
              Nimimerkkisi
            </label>
            <div className="row">
              <input
                id="nick"
                type="text"
                autoComplete="nickname"
                maxLength={gameSettings.nicknameMaxLength + 4}
                value={nickname}
                onChange={(e) => {
                  setNickname(e.target.value);
                  setError(null);
                }}
                aria-describedby="nickhelp"
              />
              <button className="btn tag" type="submit" disabled={!check.ok || busy}>
                {busy ? "Liitytään…" : "Liity"}
              </button>
            </div>
            <p id="nickhelp" className="muted small">
              {nickname && !check.ok
                ? check.reason
                : `${gameSettings.nicknameMinLength}–${gameSettings.nicknameMaxLength} merkkiä. Nimimerkki näkyy muille pelaajille.`}
            </p>
            <ErrorBox error={error} />
          </form>
        )}
        {state && <p className="muted">Pelaajia mukana: {state.players.filter((p) => p.active).length}</p>}
      </main>
    </>
  );
}
